import script from "./email-signatures-configuration-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./email-signatures-configuration-modal.vue?vue&type=script&setup=true&lang=ts"

import "./email-signatures-configuration-modal.vue?vue&type=style&index=0&id=016a2288&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016a2288"]])

export default __exports__